import { Suspense, lazy } from "react";
import Auth0AuthProvider from "./Auth0Provider";
import Loader from "../components/Loader";
import { getAuthProviderName } from "../utils/config";

// Lazy-load Keycloak so the keycloak-js bundle only ships to users when
// Keycloak is the selected provider. Auth0AuthProvider stays eager — its boot
// sequence is byte-for-byte identical to the pre-existing implementation.
const KeycloakAuthProvider = lazy(() => import("./KeycloakAuthProvider"));

interface Props {
  children: JSX.Element;
}

const AuthProvider = ({ children }: Props) => {
  if (getAuthProviderName() === "keycloak") {
    return (
      <Suspense fallback={<Loader />}>
        <KeycloakAuthProvider>{children}</KeycloakAuthProvider>
      </Suspense>
    );
  }

  return <Auth0AuthProvider>{children}</Auth0AuthProvider>;
};

export default AuthProvider;
